import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useThemeMode } from '../ThemeModeContext';

/**
 * Light and dark.
 *
 * Icon-only, so it carries an aria-label; the tooltip alone is not readable by
 * a screen reader. It shows the mode you would switch *to*, which is the
 * convention people already expect from this control.
 */
const ThemeModeToggle = ({ sx }) => {
  const { mode, toggleThemeMode, supportsDark } = useThemeMode();
  const next = mode === 'dark' ? 'light' : 'dark';

  // The active design guide may have no dark palette. Offering a switch that
  // changes nothing is worse than not offering one.
  if (!supportsDark) return null;

  return (
    <Tooltip title={`Switch to ${next} mode`}>
      <IconButton
        onClick={toggleThemeMode}
        aria-label={`Switch to ${next} mode`}
        color="inherit"
        sx={sx}
      >
        {mode === 'dark' ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeModeToggle;
